import React from 'react';
import { useTranslation } from 'react-i18next';

const LandingPage: React.FC = () => {
  const { t } = useTranslation('landing');

  const services = t('services.items', { returnObjects: true }) as string[];

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <img src="/belagom-symbol.png" alt={t('logoAlt')} className="mx-auto h-48 mb-8" />
        <h1 className="text-4xl font-bold text-[#0B1F3A] mb-4">{t('title')}</h1>
        <p className="text-xl text-[#E5A425] font-medium">{t('tagline')}</p>
      </div>

      <div className="space-y-8 text-gray-700">
        <section>
          <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-4">{t('about.title')}</h2>
          <p className="mb-4">{t('about.description')}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-4">{t('services.title')}</h2>
          <ul className="list-disc pl-6 space-y-2">
            {Array.isArray(services) && services.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-4">{t('meaning.title')}</h2>
          <p className="mb-4">{t('meaning.description')}</p>
        </section>

        <div className="text-center mt-12">
          <p className="text-lg font-medium">{t('cta')}</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
